export default "__VITE_ASSET__xNOXpe9K__"